import subscription from '../assets/project/subscription.jpg'
import flip_card from '../assets/project/flip_card.jpg'
import tier_list from '../assets/project/tier_list.jpg'
import authen from '../assets/project/authen.jpg'
import fake_news_crypto from '../assets/project/fake_news_crypto.jpg'
import fake_news_crypto_webadmin from '../assets/project/fake_news_crypto_webadmin.jpg'
import css_battle from '../assets/project/css_battle.jpg'
import just_quiz from '../assets/project/just_quiz.jpg'
import import_export from '../assets/project/import_export.jpg'
import nextcoffee from '../assets/project/nextcoffee.jpg'
import redux_cart from '../assets/project/redux_cart.jpg'
import responsive from '../assets/project/responsive.jpg'

export const frontend_item = [
    {
        key: 1,
        title: 'Subscription',
        image: subscription,
        url: '/subscription'
    },
    {
        key: 2,
        title: 'Flip Card',
        image: flip_card,
        url: '/flipcard'
    },
    {
        key: 3,
        title: 'Tier list',
        image: tier_list,
        url: '/tierlist'
    },
    {
        key: 4,
        title: 'Authenication',
        image: authen,
        url: '/authen'
    },
    {
        key: 5,
        title: 'CSS Battle',
        image: css_battle,
        url: '/css_battle'
    },
    {
        key: 6,
        title: 'Just Quiz',
        image: just_quiz,
        url: '/just_quiz'
    },
    {
        key: 7,
        title: 'Import & Export',
        image: import_export,
        url: '/import_export'
    },
    {
        key: 8,
        title: 'Redux Cart',
        image: redux_cart,
        url: '/redux/cart'
    },
    {
        key: 9,
        title: 'Responsive Landing Page',
        image: responsive,
        url: '/responsive/home'
    }
]


export const mern_item = [
    {
        key: 1,
        title: 'Web blog',
        image: fake_news_crypto,
        url: 'https://mystifying-pasteur-59d14d.netlify.app'
    },
    {
        key: 2,
        title: 'Web blog Admin',
        image: fake_news_crypto_webadmin,
        url: 'https://fakes-news-crypto-webadmin.vercel.app',
    },
    {
        key: 3,
        title: 'Next Coffee',
        image: nextcoffee,
        url: 'https://nextcoffee.vercel.app/',
    },
]